<template>
  <div>
    <Panel module="Movimentação" title="Gerar Retorno" layout="large" :showFilter="false" :showSearch="false"
      :showButtons="false">
      <div slot="content-main">
        <GenerateReturn :rentId="rentId" />
      </div>
    </Panel>
  </div>
</template>
<script>
import Panel from "@nixweb/nixloc-ui/src/component/layout/Panel";
import GenerateReturn from "../../../components/modules/stock/moviment/return/GenerateReturn.vue";

import { mapMutations } from "vuex";

export default {
  name: "GenerateOutputView",
  components: {
    Panel,
    GenerateReturn,
  },
  data() {
    return {
      rentId: this.$route.params.id,
    };
  },
  mounted() {
    this.removeLoading(["panel"]);
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
  },
};
</script>